import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Favorite } from '@yme/assets/icons';
import { Button, NO_ICON, CONTAINED_VARIANT, SIZE_44 } from '@yme/atoms/button';
import { MD_MODAL, StaticModalWindow } from '@yme/atoms/modal-window';
import { ICON_SIZE, SVGIcon } from '@yme/atoms/svg-icon';
import { getAuthorizedStatus } from '@yme/components/Header/ProfileMenu/redux/selectors';
import { useProfileMenu } from '@yme/components/Header/SignInMenuItem/useProfileMenu';
import { setIsModalHide } from '@yme/modals/actions';
import { getRTL } from '@yme/selectors/common';
import { useTranslation } from '@yme/services/i18n';
import { colorCoreBlack300 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { INDENT } from '@yme/tokens/sizes';
import { RegularTextLevel3 } from '@yme/tokens/typography';
import { DefaultModalContentStyled, DefaultModalContentTextStyled, IconWrapper } from './styled';
export function LoginRequiredModal() {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { signInHandler } = useProfileMenu();
    const isRightToLeft = useSelector(getRTL);
    const isAuthorized = useSelector(getAuthorizedStatus);
    const signInModalMessage = t('wishlist_loginRequired_message');
    const signInModalTip = t('wishlist_loginRequired_tip');
    const signInButtonLabel = t('wishlist_loginRequired_button');
    const signInModalTitle = t('wishlist_loginRequired_header');
    useEffect(() => {
        if (isAuthorized) {
            dispatch(setIsModalHide());
        }
    }, [dispatch, isAuthorized]);
    return (React.createElement(StaticModalWindow, { staticModalSize: MD_MODAL, title: signInModalTitle, isRightToLeft: isRightToLeft },
        React.createElement(DefaultModalContentStyled, { fullWidth: true },
            React.createElement(FlexWrapper, { justifyContent: "center", isFullWidth: true, mb: INDENT.sm },
                React.createElement(IconWrapper, null,
                    React.createElement(SVGIcon, { type: Favorite, size: ICON_SIZE.xs }))),
            React.createElement(DefaultModalContentStyled, null,
                React.createElement(RegularTextLevel3, { color: colorCoreBlack300 }, signInModalMessage)),
            React.createElement(DefaultModalContentTextStyled, null,
                React.createElement(RegularTextLevel3, { color: colorCoreBlack300 }, signInModalTip)),
            React.createElement(DefaultModalContentStyled, null,
                React.createElement(Button, { label: signInButtonLabel, hasIconButton: NO_ICON, onClick: signInHandler, buttonVariant: CONTAINED_VARIANT, size: SIZE_44 })))));
}
